"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _editorConfigs = require("composer-lib/lib/editorConfigs");

var _ComposerSettings = _interopRequireDefault(require("composer-lib/data/model/ComposerSettings"));

var _draftJs = require("draft-js");

var _draftExtend = require("draft-extend");

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UIExpandingTextArea = _interopRequireDefault(require("UIComponents/input/UIExpandingTextArea"));

var _default = (0, _createReactClass.default)({
  displayName: "RevisionPreview",
  propTypes: {
    composerSettings: _propTypes.default.instanceOf(_ComposerSettings.default),
    getEditorProps: _propTypes.default.func.isRequired,
    revision: _propTypes.default.object
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var composerSettings = this.props.composerSettings;
    var props = this.props.getEditorProps();
    this.editorWithPlugins = (0, _editorConfigs.bodyEditorConfig)(composerSettings.richTextStyles, composerSettings.features, composerSettings.betas, {
      props: props
    })(_draftExtend.Editor);
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var prevRevision = prevProps.revision;
    var revision = this.props.revision;

    if (!prevRevision && revision || prevRevision && revision && prevRevision.id !== revision.id) {
      document.querySelector('.preview-top').scrollIntoView();
    }
  },
  renderTitlePreview: function renderTitlePreview() {
    return _react.default.createElement("div", {
      className: "revision-preview-title composition-title-container m-left-0"
    }, _react.default.createElement(_UIExpandingTextArea.default, {
      className: "composition-title",
      readOnly: true,
      styled: false,
      value: this.props.revision.object.title
    }));
  },
  renderBodyPreview: function renderBodyPreview() {
    var rawContent = JSON.parse(this.props.revision.object.body);
    var editorState = rawContent ? _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(rawContent)) : _draftJs.EditorState.createEmpty();
    return _react.default.createElement("div", {
      className: "m-left-3 revision-preview-body composition-body"
    }, _react.default.createElement(this.editorWithPlugins, {
      editorState: editorState,
      onChange: _emptyFunction.default,
      readOnly: true,
      showButtons: false
    }));
  },
  render: function render() {
    var revision = this.props.revision;

    if (!revision) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "revision-preview-container composer-container"
    }, _react.default.createElement("div", {
      className: "preview-top"
    }), this.renderTitlePreview(), this.renderBodyPreview());
  }
});

exports.default = _default;
module.exports = exports.default;